import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import createHistory from 'history/createBrowserHistory';
import { withRouter } from 'react-router';
import { ConnectedRouter, routerMiddleware } from 'react-router-redux';
import throttle from 'lodash/throttle';
import { createLogger } from 'redux-logger';

import { ActionLogger } from './middleware/ActionLogger/ActionLogger';
import { setupInit } from './components/SetupLoader/setupLoaderActions';
import { checkSubscriptionStatus } from './components/Auth/authActions';

import App from './app/App';
import reducers from './app/reducers';
import { loadState, saveState} from './localStorage';

const isDevelopment = process.env.REACT_APP_ENV === 'development' || typeof process.env.REACT_APP_ENV === 'undefined';

//console.log('Current environment: ' + process.env.REACT_APP_ENV);

const history = createHistory();
const routeMiddleware = routerMiddleware(history);

const loggerMiddleware = createLogger();
const reduxMiddlewares = isDevelopment ?
    // [thunk, routeMiddleware, ActionLogger, loggerMiddleware]: // Activate redux logger
    [thunk, routeMiddleware, ActionLogger]:
    [thunk, routeMiddleware, ActionLogger];

loadState.then((persistedState) => {
    const store = createStore(
        reducers,
        persistedState,
        applyMiddleware.apply(undefined, reduxMiddlewares)
    );
    store.subscribe(throttle(() => {
        saveState(store.getState());
    }, 1000));

    store.dispatch(setupInit());

    const AppWithRouter = withRouter(App);
    
    render(
        <Provider store={ store }>
            <ConnectedRouter history={history}>
                <AppWithRouter />
            </ConnectedRouter>
        </Provider>,
        document.getElementById('root')
    );
})


// WEBPACK FOOTER //
// ./src/index.js